import {
    appConfig as packageAppConfig,
    IConfig,
} from 'srs.sharedcomponents/lib/esm/config/app.config';
import { t as baseT } from 'i18next';
import { i18nNamespaces as namespace } from 'srs.sharedcomponents/lib/esm/i18n/i18n';
import coreSrsPrimaryOverride from '../i18n/coreSrsPrimaryOverride.json';

const translate = (
    key: string,
    nameSpaceOrOptions?: string | Record<string, string>,
    maybeOptions?: Record<string, string>
): string => {
    if (typeof nameSpaceOrOptions === 'string') {
        return baseT(key, { ...(maybeOptions || {}), ns: nameSpaceOrOptions });
    }

    const getCurrentLanguage = (): string => {
        const storedLang = localStorage.getItem('i18nextLng');
        if (storedLang) return storedLang;

        const browserLang = navigator.language;
        if (browserLang) return browserLang;

        return 'en_US';
    };

    const currentLang = getCurrentLanguage();
    const overrideTranslations =
        coreSrsPrimaryOverride[
            currentLang as keyof typeof coreSrsPrimaryOverride
        ];

    if (
        overrideTranslations &&
        overrideTranslations[key as keyof typeof overrideTranslations]
    ) {
        return overrideTranslations[
            key as keyof typeof overrideTranslations
        ] as string;
    }

    const fallbackTranslations = coreSrsPrimaryOverride['en_US'];
    if (
        fallbackTranslations &&
        fallbackTranslations[key as keyof typeof fallbackTranslations]
    ) {
        return fallbackTranslations[
            key as keyof typeof fallbackTranslations
        ] as string;
    }

    return baseT(key, {
        ...(nameSpaceOrOptions || {}),
        ns: namespace.coreSrsPrimary,
    });
};

export const appConfig: IConfig = {
    ...packageAppConfig,
    disableContinueShoppingButton: true,
    disableWishListButton: true,
    disableLeftNavForProductListCatalogue: false,
    wishListButtonRoutes: ['/'],
    categoryConfig: [{ category: 'Keys', redirectUrl: '/keyfinder' }],
    productTypeLabels: {
        29: 'txtServicePartNumber',
    },
};
